export interface IUpdateCommentInput {
  body: string;
  id: string;
}

class UpdateCommentInput {
  public readonly body: string;
  public readonly id: string;

  constructor({ body, id }: { body: string; id: string }) {
    this.body = body;
    this.id = id;
  }

  public toJSON = () => ({
    body: this.body,
    id: this.id,
  });

  public static fromJSON = (json: IUpdateCommentInput): UpdateCommentInput => {
    const { body, id } = Object.assign({}, json);

    if (typeof body !== 'string') throw new Error('.body must be a string');
    if (typeof id !== 'string') throw new Error('.id must be a string');

    return new UpdateCommentInput({
      body,
      id,
    });
  };
}

export default UpdateCommentInput;
